__webpack_require__.p = "/mana/view/selfstudy/";